module.exports = __webpack_public_path__ + "img/631.problem_sink.60130b1c.svg";